const ReportTemplateGroupCalculation = (data) => {
  const { group_data, group_label, key, list_data, report_type } = data;

  let count = 0;
  if (list_data) {
    count = list_data.length;
  }
  data.group_count = count;
  data.total_quantity = list_data.reduce((acc, curr) => acc + curr.quantity, 0);

  return data;
};

export default ReportTemplateGroupCalculation;
